import { gql } from '@apollo/client';
import { Order } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';

export const VerifyBancoEstadoJwt = () => gql`
  mutation VerifyBancoEstadoJwt($params: VerifyBancoEstadoJwtParams!) {
    verifyBancoEstadoJwt(params: $params) {
      uuid
      orders {
        id
        uuid
        status
        orderGroupId
        address {
          id
          name
          street
          streetNumber
          commune
        }
      }
      totalPrice
      deliveryPrice
    }
  }
`;

export type VerifyBancoEstadoJwtParams = ResolverParams<{
  jwt: string;
}>;

export type VerifyBancoEstadoJwtResponse = {
  verifyBancoEstadoJwt: {
    uuid: string | null;
    orders: Order[];
    totalPrice: number;
    deliveryPrice: number;
  };
};
